
export default function ScenesSection() {
  const scenes = [
    {
      id: 1,
      title: 'どこでも整う、"描くための空間"',
      description: 'カフェでも、移動中でも。広げるだけで、そこがあなたのアトリエになる。',
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/53a45812140d6404e92176e162ec84e4.jpeg',
      icon: 'ri-compass-3-line',
    },
    {
      id: 2,
      title: 'デスクで、集中して描き込む',
      description: '安定した角度で、細部まで丁寧に。長時間の作業も快適に。',
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/e5997203830ee236bda2f1fe985e66b6.jpeg',
      icon: 'ri-focus-3-line',
    },
    {
      id: 3,
      title: '縦向きで、インプットに集中する時間に',
      description: '読書、リサーチ、学習。縦向きスタンドで、情報収集に没頭する。',
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/3bfa27b58a54ae03bb44059b917a142d.jpeg',
      icon: 'ri-book-read-line',
    },
    {
      id: 4,
      title: '手元の書類をそのままデジタルへ',
      description: 'PDFに手書きメモ、資料への注釈。紙の感覚で、デジタルワークを。',
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/cf54388d7c7d0e6b1b364d383a34653f.jpeg',
      icon: 'ri-file-edit-line',
    },
    {
      id: 5,
      title: '"見る・楽しむ"時間を心地よく',
      description: '動画視聴、オンラインミーティング。最適な角度で、画面を楽しむ。',
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/1df623f5b88afb0e023f55d534653838.png',
      icon: 'ri-play-circle-line',
    },
    {
      id: 6,
      title: '膝の上で、思いつきをその場でかたちに',
      description: 'ソファで、ベッドで。ふと浮かんだアイデアを、すぐにスケッチ。',
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/24c71384e9e34cf0594592186b8b0093.jpeg',
      icon: 'ri-lightbulb-flash-line',
    },
  ];

  return (
    <section id="scenes" className="py-24 px-6 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto">
        {/* 見出し */}
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.3em] text-[#8B6BAE] uppercase mb-3">Use Scenes</p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            あなたの日常に、<span className="text-[#8B6BAE]">溶け込む</span>
          </h2>
          <p className="text-base text-[#9B9B9B] max-w-2xl mx-auto">
            場所を選ばず、シーンに合わせて。Atelier Folioがある暮らし。
          </p>
        </div>

        {/* シーングリッド */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {scenes.map((scene) => (
            <div
              key={scene.id}
              className="group bg-white rounded-lg overflow-hidden border border-[#F0F0F0] hover:border-[#8B6BAE]/30 transition-all"
            >
              {/* 画像 */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={scene.image}
                  alt={scene.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                
                {/* シーン番号 */}
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center justify-center w-7 h-7 bg-white/95 rounded-full text-xs font-semibold text-[#8B6BAE]">
                    {scene.id}
                  </span>
                </div>
              </div>

              {/* コンテンツ */}
              <div className="p-5">
                <div className="flex items-start gap-2.5 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#F5F5F5] rounded-lg flex-shrink-0">
                    <i className={`${scene.icon} text-base text-[#8B6BAE]`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-[#2C2C2C] leading-tight">
                    {scene.title}
                  </h3>
                </div>
                <p className="text-sm text-[#9B9B9B] leading-relaxed pl-10.5">
                  {scene.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
